export const ResetLink = async (email, redirectUrl) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${window.constants.api_url}/forgot-password`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ email, redirect_url: redirectUrl }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return { code: "error", message: "An error occurred" };
  }
};

export const newPassword = async (password, token) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${window.constants.api_url}/set-new-password`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({ token, password, password_confirmation: password }),
      redirect: "follow",
    });
    return response.json();
  } catch (error) {
    console.error("Error:", error);
    return { code: "error", message: "An error occurred" };
  }
};
